import profile from './profile'
import keys from './keys'
import fazendas from './fazendas'
import produtos from './produtos'
import categorias from './categorias'
import unidadesmedida from './unidadesmedida'
import produtores from './produtores'
import tecnicos from './tecnicos'
import catalogos from './catalogos'
import fornecedores from './fornecedores'
import atendimento from './atendimento'
import relatorios from './relatorios'
import notificacoesTecnico from './notificacoesTecnico'
import notificacoesProdutor from './notificacoesProdutor'
import integracoes from './integracoes'
import servicos from './servicos'
import planoPagamento from './planoPagamento'

const permissions = [
  {
    role: 'admin',
    access: false,
    redirect: 'admin',
  },
  {
    role: 'gestor',
    access: false,
    redirect: 'gestor',
  },
  {
    role: 'guest',
    access: false,
    redirect: 'login',
  },
]

/* ACESSO GESTOR */
export default {
  name: 'supervisor',
  path: '/supervisor',
  redirect: '/supervisor/dashboard',
  component: () => import('@/views/Index'),
  meta: { requiresAuth: true, permissions },
  children: [
    {
      path: 'dashboard',
      component: () => import('@/views/dashboard/DashboardSupervisor'),
      meta: { permissions, title: 'Início' },
    },
    tecnicos.router(permissions),
    produtores.router(permissions),
    fazendas.router(permissions),
    produtos.router(permissions),
    categorias.router(permissions),
    unidadesmedida.router(permissions),
    profile.router(permissions),
    catalogos.router(permissions),
    fornecedores.router(permissions),
    atendimento.router(permissions),
    relatorios.router(permissions),
    keys.router(permissions),
    notificacoesTecnico.router(permissions),
    notificacoesProdutor.router(permissions),
    integracoes.router(permissions),
    servicos.router(permissions),
    planoPagamento.router(permissions),
  ],
}
